const STORE_STATUS_TYPE = {
  ACTIVE: 1,
  MAINTENANCE: 2,
  STOP_OPERATION: 3,
};

const PERMISSION_STORE = {
  VIEW: 'MD_STORE_VIEW',
  ADD: 'MD_STORE_ADD',
  EDIT: 'MD_STORE_EDIT',
  DELETE: 'MD_STORE_DELETE',
};

const TYPE_STORE_PANEL = {
  GENERAL: 'GENERAL',
  DETAIL: 'DETAIL',
  IP: 'IP',
};

const SIZE_TYPE = {
  V1: 'V1',
  V2: 'V2',
  V3: 'V3',
  V4: 'V4',
  V5: 'V5',
  V6: 'V6',
};

export { STORE_STATUS_TYPE, PERMISSION_STORE, TYPE_STORE_PANEL, SIZE_TYPE };
